import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { useContestForm } from "@/components/contest-form/useContestForm";
import { BasicInfoSection } from "@/components/contest-form/BasicInfoSection";
import { ChannelSection } from "@/components/contest-form/ChannelSection";
import { CodesSection } from "@/components/contest-form/CodesSection";
import { PrinterSection } from "@/components/contest-form/PrinterSection";
import { StoresAndCodesSection } from "@/components/contest-form/StoresAndCodesSection";

export default function CreateContestDialog({ open, onOpenChange, onCreated, contest }) {
  const { form, set, merge, submit, saving, isEdit } = useContestForm({ open, contest, onOpenChange, onCreated });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-lg max-h-[90vh] overflow-y-auto" data-testid="contest-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center justify-between gap-3">
            <span>{isEdit ? "Modifica Concorso" : "Crea Nuovo Concorso"}</span>
            {isEdit && (
              <Button data-testid="submit-contest-button-top" size="sm" onClick={submit} disabled={saving} className="gap-1.5">
                <Save className="h-3.5 w-3.5" /> {saving ? "Salvataggio…" : "Salva"}
              </Button>
            )}
          </DialogTitle>
          <DialogDescription>Imposta date, orari, probabilità e modalità dei codici per il tuo concorso Instant Win.</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <BasicInfoSection form={form} set={set} merge={merge} />
          <ChannelSection form={form} set={set} />
          <CodesSection form={form} set={set} contestId={contest?.id} />
          <StoresAndCodesSection form={form} set={set} isEdit={isEdit} contestId={contest?.id} />
          <PrinterSection form={form} set={set} />
        </div>

        <DialogFooter className="sticky bottom-0 -mx-6 -mb-6 px-6 py-4 bg-card border-t border-border">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button data-testid="submit-contest-button" onClick={submit} disabled={saving} className="gap-2">
            <Save className="h-4 w-4" /> {saving ? "Salvataggio…" : isEdit ? "Salva / Aggiorna Concorso" : "Crea Concorso"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
